import React from 'react';
import cn from 'classnames';

import ProductPromotionModel from 'coreClasses/product/Product/ProductPromotionModel';
import DangerousHTML from 'coreComponents/DangerousHtml/DangerousHTML';

import {IProductDetailPromotionsProps} from './IProductDetailPromotions';

import styles from './ProductDetailPromotions.module.scss';

const ProductDetailPromotions = ({variationGroup, classNames}: IProductDetailPromotionsProps) => {

	const promotions = variationGroup?.getProductPromotions();

	if (!promotions) {
		return null;
	}

	return (
		<>
			{promotions?.map((promotion: ProductPromotionModel) =>
				promotion.getCalloutMsg() && <DangerousHTML
					key={promotion.getPromotionId()}
					html={promotion.getCalloutMsg()}
					classNames={cn(styles['product-detail__promotion-message'], classNames)} />
			)}
		</>
	);
};

export default ProductDetailPromotions;
